module.exports = __webpack_public_path__ + "static/img/kefu.c0832af9.png";